import { OT_ALL_PREFERENCES, OT_TARGETING_ADS_PREFERENCE } from './consts'

const getActivePreferences = () => window.OnetrustActiveGroups && window.OnetrustActiveGroups.split(',').filter(group => group)

export const isPreferenceActive = cookie => window.OnetrustActiveGroups.indexOf(cookie) >= 0

// isConsentGiven => all cookies accepted
const isConsentGiven = () => (
  window.OnetrustActiveGroups
  && OT_ALL_PREFERENCES.every(cookie => window.OnetrustActiveGroups.indexOf(cookie) >= 0)
)

const isTargetingConsentGiven = () => (
  window.OnetrustActiveGroups
  && window.OnetrustActiveGroups.indexOf(OT_TARGETING_ADS_PREFERENCE) >= 0
)

// isPreferenceExpressed => users accept/reject cookies
const isPreferenceExpressed = () => (
  window.tcData
  && window.tcData.cmpStatus === 'loaded'
  && (window.tcData.eventStatus === 'useractioncomplete' || window.tcData.eventStatus === 'tcloaded')
)

export const openPreferences = () => window.OneTrust && window.OneTrust.ToggleInfoDisplay()

const getCookiesConsent = () => {
  let cookies = {
    isConsentGiven: false,
    isPreferenceExpressed: false,
    isTargetingConsentGiven: false,
    preferences: [],
    tcString: undefined,
    gdprApplies: undefined,
  }

  if (window.tcData && window.OnetrustActiveGroups) {
    cookies = {
      isConsentGiven: isConsentGiven(),
      isPreferenceExpressed: isPreferenceExpressed(),
      isTargetingConsentGiven: isTargetingConsentGiven(),
      preferences: getActivePreferences(),
      tcString: window?.tcData?.tcString,
      gdprApplies: window?.tcData?.gdprApplies,
    }
  }

  return cookies
}

export default getCookiesConsent
